<div class="dialog-wrapper">
  <h3 mat-dialog-title>{{ data.title }}</h3>
  <div mat-dialog-content>
    @if (data.message) {
      <div class="text">{{ data.message }}</div>
    }
    <div [formGroup]="form">
      @if (isWipe) {
        <div class="device-action-form">
          <mat-checkbox formControlName="keepEnrollmentData">{{ 'app.device.actions.dialog.keep_enrollment_data' | translate }}</mat-checkbox>
          <mat-checkbox formControlName="keepUserData">{{ 'app.device.actions.dialog.keep_user_data' | translate }}</mat-checkbox>
          <!-- <mat-form-field appearance="outline" class="unlock-code-field">
            <mat-label>{{ 'app.device.actions.dialog.macos_unlock_code_label' | translate }}</mat-label>
            <input matInput formControlName="macOsUnlockCode" type="text" [placeholder]="'app.device.actions.dialog.macos_unlock_code_placeholder' | translate" />
          </mat-form-field> -->
        </div>
      }
      @if (isFreshStart) {
        <div class="device-action-form">
          <mat-checkbox formControlName="keepUserData">{{ 'app.device.actions.dialog.keep_user_data' | translate }}</mat-checkbox>
        </div>
      }
    </div>
  </div>
  <div mat-dialog-actions>
    <div class="dialog-actions">
      <button mat-raised-button class="cancelButton" (click)="onCancel()">
        <span>{{ 'shared.general.buttons.cancel' | translate }}</span>
      </button>
      <button mat-flat-button color="primary" class="confirmButton" (click)="onSubmit()">
        <span>{{ 'shared.general.buttons.confirm' | translate }}</span>
      </button>
    </div>
  </div>
</div>
